import React from 'react';

/**
 * O texto do Finn, como a bolha o mostra.
 *
 * As respostas escritas pelo código nascem para os DOIS canais, e usam as
 * marcas do WhatsApp: `*negrito*`, `_itálico_`. No WhatsApp o aplicativo as
 * desenha. Na bolha elas apareciam cruas: a resposta do glossário terminava
 * com "_Mais na fonte oficial: https://…_", com os sublinhados à vista e o
 * endereço sem ser link (13/10, no vídeo que ela gravou).
 *
 * Aqui as marcas viram ênfase de verdade e o endereço vira link. Sem
 * `dangerouslySetInnerHTML`: o texto é partido e cada pedaço vira um nó, então
 * nada do que o servidor mandar é interpretado como HTML.
 */

const URL = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?_])/g;

/** O endereço sem o "https://www." e sem a barra do fim, para caber numa linha. */
const enderecoCurto = (url: string): string => {
  const sem = url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
  return sem.length > 46 ? `${sem.slice(0, 44)}…` : sem;
};

/** Dentro de uma linha: endereços viram link, `*x*` vira negrito. */
const emLinha = (texto: string, chave: string): React.ReactNode[] => {
  const nos: React.ReactNode[] = [];
  texto.split(URL).forEach((pedaco, i) => {
    if (i % 2 === 1) {
      nos.push(<a key={`${chave}-u${i}`} href={pedaco} target="_blank" rel="noopener noreferrer">{enderecoCurto(pedaco)}</a>);
      return;
    }
    pedaco.split(/(\*[^*\n]+\*)/g).forEach((p, j) => {
      if (/^\*[^*\n]+\*$/.test(p)) nos.push(<strong key={`${chave}-b${i}-${j}`}>{p.slice(1, -1)}</strong>);
      else if (p) nos.push(p);
    });
  });
  return nos;
};

/** O texto inteiro: a linha `_assim_` vira nota em itálico; as outras, texto com ênfase. */
export const textoDoFinn = (texto: string): React.ReactNode[] =>
  texto.split('\n').flatMap((linha, i, todas) => {
    const nota = linha.match(/^_(.+)_$/);
    const no = nota
      ? <em key={`l${i}`} className="aa-nota-do-texto">{emLinha(nota[1], `l${i}`)}</em>
      : <React.Fragment key={`l${i}`}>{emLinha(linha, `l${i}`)}</React.Fragment>;
    return i < todas.length - 1 ? [no, '\n'] : [no];
  });
